import activeEmail from './modules/store'
import pageTokens from './modules/pageTokens'
import newMessage from './modules/newMessage'

export const modules = {
  activeEmail,
  pageTokens,
  newMessage
}



// WEBPACK FOOTER //
// ./src/store/Email/index.js